module.exports = __webpack_public_path__ + "02_very_short_yellow.a1bce6ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_very_short_yellow.png
// module id = L8q0
// module chunks = 0